import { render, staticRenderFns } from "./LmSimpleCard.vue?vue&type=template&id=a7fe1dea&scoped=true&"
import script from "./LmSimpleCard.vue?vue&type=script&lang=js&"
export * from "./LmSimpleCard.vue?vue&type=script&lang=js&"
import style0 from "./LmSimpleCard.vue?vue&type=style&index=0&id=a7fe1dea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fe1dea",
  null
  
)

export default component.exports